<template>
  <b-dropdown right :text="summaryText" variant="outline-dark" @hide="saveChanges" ref="dropdown" :disabled="disabled">
    <b-dropdown-form style="min-width:320px" v-on:submit.prevent.stop="saveAndClose">
      <b-form-group label="Match if value:">
        <b-input-group>
          <b-form-select v-model="operator">
            <option value="null" disabled>Please select an option</option>
            <option value="starts">Starts with</option>
            <option value="equal">Is exactly</option>
          </b-form-select>
          <b-input v-model="value" maxlength="80"></b-input>
        </b-input-group>
      </b-form-group>
      <b-alert :show="!isValid" variant="danger">{{errorMessage}}</b-alert>
      <p class="text-right mb-0">
        <b-button size="sm" variant="secondary" @click="resetAndClose">Cancel</b-button>
        <b-button size="sm" variant="primary" @click="saveAndClose">Update</b-button>
      </p>
    </b-dropdown-form>
  </b-dropdown>
</template>

<script>

export default {
  name: 'JobNumberFilter',
  props: ['filter', 'disabled'],
  components: {},
  data () {
    return {
      summaryText: this.summaryTextForFilter(this.filter),
      operator: this.filter.operator || null,
      value: this.filter.value,
      isValid: true,
      errorMessage: ''
    }
  },
  computed: {},
  watch: {
  },
  mounted () {
  },
  methods: {
    summaryTextForFilter (filter) {
      if (filter.operator != null) {
        const operatorString = {
          'starts': 'Starts',
          'equal': 'Is'
        }[filter.operator] || filter.operator
        return `${operatorString} ${filter.value}`
      } else {
        return 'None'
      }
    },
    validate () {
      this.isValid = true
      if (this.operator == null) {
        this.isValid = false
        this.errorMessage = 'Please select a match type'
      } else if (this.value == null || this.value === '') {
        this.isValid = false
        this.errorMessage = 'Please enter a match value'
      }
      return this.isValid
    },
    resetAndClose (evt) {
      this.operator = this.filter.operator
      this.value = this.filter.value
      this.isValid = true
      this.errorMessage = ''
      this.$refs.dropdown.hide()
    },
    saveChanges (evt) {
      if (this.validate()) {
        this.commit()
      } else {
        evt.preventDefault()
      }
    },
    saveAndClose () {
      if (this.validate()) {
        this.$refs.dropdown.hide()
      }
    },
    commit () {
      this.filter.operator = this.operator
      this.filter.value = this.value
      this.summaryText = this.summaryTextForFilter(this.filter)
      this.$emit('input', this.filter)
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/reports/JobNumberFilter.vue